import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'
import { getHotelInfo } from 'b2b-common/services/api/hotel'

export default {
  data () {
    return {
      modal: false,
      priceDetailsModal: false,
      infoResults: [],
      selectedResults: [],
      selectedPriceFilters: null,
      searchIsRunning: false,
      currentPage: 1,
      resultsPerPage: Number.MAX_SAFE_INTEGER,
      priceFilters: [
        { text: 'toate rezultatele', value: null },
        { text: 'pret: < 100', value: { min: Number.MIN_SAFE_INTEGER, max: 100 } },
        { text: 'pret: 100 - 500', value: { min: 100, max: 500 } },
        { text: 'pret: 500 - 1000', value: { min: 100, max: 500 } },
        { text: 'pret: > 1000', value: { min: 1000, max: Number.MAX_SAFE_INTEGER } }
      ]
    }
  },
  computed: {
    paginatedResults () {
      return this.model.results.slice((this.currentPage - 1) * this.resultsPerPage, this.currentPage * this.resultsPerPage)
    },
    filteredResults () {
      if (!this.selectedPriceFilters) return this.model.results
      return this.model.results.filter(el =>
        (el.gross > this.selectedPriceFilters.min) && (el.gross <= this.selectedPriceFilters.max)
      )
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
      // document.getElementById('resultsHr').scrollIntoView()
    },
    async attachHotelInfo (results) {
      const hotels = []
      // get list of hotels without hotelInfo
      results.forEach(result => {
        if (!result.hotelInfo) {
          hotels.push(result.id)
        }
      })

      // obtain hotelInfo for all hotels
      const info = hotels.length ? await getHotelInfo({ hotels }) : []

      if (!Array.isArray(info)) return 0

      info.forEach(hotel => {
        const list = results.filter(result => result.id === hotel.id)
        list.forEach(result => { result.hotelInfo = hotel })
      })

      return info.length
    },
    async onInfo (results) {
      await this.attachHotelInfo(results)
      this.infoResults = results
      this.modal = true
    },
    async onInfoSelected () {
      await this.attachHotelInfo(this.selectedResults)
      this.infoResults = this.selectedResults
      this.modal = true
    },
    onHideSelected () {
      this.selectedResults = []
    },
    isSelected (result) {
      return this.selectedResults.indexOf(result) >= 0
    },
    onToggle (result) {
      const index = this.selectedResults.indexOf(result)
      if (index >= 0) this.selectedResults.splice(index, 1)
      else this.selectedResults.push(result)
    },
    onModalClose () {
      this.modal = false
    },
    priceDetails () {
      this.priceDetailsModal = true
    },
    closePriceDetailsModal () {
      this.priceDetailsModal = false
    },
    onPrint () {
      const html = document.getElementById('printArea').innerHTML
      openPrintPage({ html })
    },
    onDownload () {
      const html = document.getElementById('printArea').innerHTML
      getCustomPdf({ html })
        .then(pdfData => {
          downloadPdf({ pdfData, fileName: 'oferta.pdf', dataType: 'raw' })
        })
    },
    onSort (sortMethod) {
      this.model.sort({ sortMethod })
    },
    onPriceFilter (filter) { this.selectedPriceFilters = filter },
    onPaginate (noResults) {
      this.resultsPerPage = noResults
    },
    onSearch (params) {
      this.searchIsRunning = true
      this.infoResults = []
      this.model.search(params)
        .finally(() => { this.searchIsRunning = false })
    }
  }
}
